module.exports = __webpack_public_path__ + "fonts/beauty-and-the-beast-sample.e6fe4d2.woff2";